import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { setCurMenuAction, setHeaderTransferAction } from '../../modules/common/headerModule';
import { setStLocAction, reqStItemAction, reqStContentsDetailAction } from '../../modules/st/stContentsModule';
import IconBtn from '../../components/common/button/IconBtn';
import SpaceCardItem from '../../components/st/SpaceCardItem';
import SpaceEsSlider from '../../components/st/SpaceEsSlider';
import SrMyCartBanner from '../../components/common/banner/SrMyCartBanner';
import { forEach, findIndex, remove } from 'lodash';
import SpanPrice from '../../components/common/price/SpanPrice';

import { LoginPopupStyles } from '../../components/common/popup/LoginPopup';
import LoginPopup from '../../components/common/popup/LoginPopup';
import { setUserSpaceAddAction, setUserSpaceDelAction, setClipSpaceIdAction, spaceAction } from '../../modules/su/userSpaceModule';
import Modal from 'react-modal';
import { useRef } from 'react';
import $ from 'jquery';

import { isMobileOnly } from 'react-device-detect';

import SubmitBtn from '../../components/common/button/SubmitBtn';
import NormalBtn from '../../components/common/button/NormalBtn';
import NormalPopupOneBtn from '../../components/common/popup/NormalPopupOneBtn';
import { setUserCartProdsAction, syncUserCartAction, setUserReqProdsListAction } from '../../modules/su/userCartModule';
import { esApplyProdDao, esApplyOptionDao, setEsApplyProdAction } from '../../modules/es/esApplyModule';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';
import EsReqForStPopup, { EsReqForStPopupModalStyles } from '../../components/common/popup/EsReqForStPopup';
import * as CONSTANTS from '../../lib/util/Constants';

const SpaceDetailBlock = styled.div`
  -webkit-overflow-scrolling: touch;

    ${isMobileOnly && `.bottom-banner {display:block; margin:0 4vw;}`};
  
  .brand-container {
    ${isMobileOnly && `margin:16vw 0`};
    
    .brand-contents-box {
      ${isMobileOnly && `display: flex; justify-content: space-between; `};   
    }
    
    .pd_brand-box {
        ${isMobileOnly ? `min-width:40vw; margin-right:0;` : 'margin-right:16px'};
     }
  }
`;

const SpaceDetailContainerBlock = styled.div`
    ${!isMobileOnly && "width: 100%"};
    max-width: 1176px;
    margin: 30px ${isMobileOnly ? "4vw" : "auto"};
    padding: 100px 0 130px;
`;

const SpaceHeaderBlock = styled.div`
    position: fixed;
    top: ${isMobileOnly ? "60px" : "81px"};
    left: 0;    
    width: 100%;
    padding: ${isMobileOnly ? "20px 4vw" : "33px 0"};
    background-color: #fff;
    z-index: 30;
    border-bottom: 1px solid #e7e7e7;
    

    .sz-wrap {
        position: relative;
        max-width : 1176px;
    }

    .sd-no {
        ${!isMobileOnly && `
            position: absolute;
            top: 10px;
            left: 0;        
        `};
    }

    .sd-title {
        ${isMobileOnly && "margin-top:1rem"};
        font-size: 20px;
        text-align: center;
    }

    .sd-title .sd-logo {
        display: inline-block;
        margin-right: 18px;
        vertical-align: -5px;
    }

    .sd-title .sd-logo img {
        height: 20px;
    }

    .sd-fc {
        position: absolute;
        top: ${isMobileOnly ? "-5px" : "0"};
        right: 0;
    }

`;

const SpaceContentsBlock = styled.div`
    position: relative;
    padding: 50px 0 0 0;
    width : ${isMobileOnly ? "unset" : "1176px"};

    ${isMobileOnly ? `
        width: unset;
        .show-more { margin: 0 auto;}
    `: `
        width: 1176px;
        .show-more, .divider {display: none;}    
    `}; 
     
    .clearfix::after {
        content: "";
        display: block;
        clear: both;
    }

    .sd-product_info {
        ${isMobileOnly ? `float: none` : `float: left`};        
        width: ${isMobileOnly ? "unset" : "856px"};
        margin-bottom: ${isMobileOnly ? "50px" : "100px"};
        padding-right: ${isMobileOnly ? "0" : "24px"};
        position: relative;
        transition: max-height .3s ease-in;
                
        ${isMobileOnly && `
       
        &.hidden-on-mobile {
          // border-bottom: 1px solid #ccc;
          max-height:100vh; 
          overflow: hidden;
          transition: max-height .3s ease-out;
          
          &:before {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 10;
            height: 200px;
            background-image: linear-gradient(to bottom, rgba(255,255,255,0), #fff);
            content: '';                        
          }
        }
        `};

        max-height: 100%;
        //transition: max-height 0.25s ease-in;
        
      }  

    .sd-es_box {
        ${isMobileOnly ? `
            float: none;
            width: unset;
        `: `
            float: right;
            width: 314px;        
        `};
        -webkit-transition: -webkit-transform 0.3s 0.1s;
        transition: -webkit-transform 0.3s 0.1s;
        -o-transition: transform 0.3s 0.1s;
        //transition: transform 0.3s 0.1s;
        transition: transform 0.3s 0.1s, -webkit-transform 0.3s 0.1s;
    }
    .sd-es_box .product-table {
    max-height: ${isMobileOnly ? "unset" : "400px"};
    overflow: auto;
    }
    .sd-es_box .product-table table {
    border-top: none;
    }
    .sd-es_box .sd-limit_date {
    font-size: 14px;
    }
    .sd-es_box .sd-pay {
    padding: 11px 20px;
    color: #fff;
    background-color: #111;
    border-radius: 46.5px;
    font-size: 14px;
    font-weight: 300;
    }
    .sd-es_box .sd-pay .pay-detail {
    font-size: ${isMobileOnly ? "20px" : "34px"};
    font-weight: 700;
    }

    .action-block {
        ${isMobileOnly ? `display:flex` : "margin-top:14px"};
        
      }
`;

const ProdItemPBlock = styled.p`
    margin-bottom: 20px;    
    min-height: 155px;
    cursor: pointer;
    line-height : 155px;
`;
const BtnShowMoreBlock = styled.button`
    font-size: 0.9em;
    font-weight: 500;
    color: #111;
    //background-color: #ffc742;
    border: 1px solid #111;
    -webkit-box-shadow: 7px 5px 16px 0 rgba(0,0,0,0.42);
    -moz-box-shadow: 7px 5px 16px 0 rgba(0,0,0,0.42);
    box-shadow: 7px 5px 16px 0 rgba(0,0,0,0.42);
    width: 92vw;
    //line-height: normal;
    padding: 0.5rem 0;
    display: block; 
    overflow:hidden;
    position:absolute;
    bottom:0;
    z-index:10;
    background-color:#fff;
`;
const ProdListItemImg = styled.img`
    border-radius: 4px;
    min-width: 100%; 
    min-height: 100%;
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
    max-height: 155px;
    max-width : 155px;
    vertical-align : middle;
    object-fit: cover;
`;

const SpaceProdItemPBlock = styled.div`
    line-height : 60px;
`;

const SpaceProdItemDimPBlock = styled.div`
    position: absolute;
    top: 0;
    width: 70px;
    height: 70px;
    overflow: hidden;
    //border-radius: 4px;
    background-color: rgba(255,255,255,0.7);
    pointer-events: none;
`;

const SpaceProdListItemImg = styled.img`
    border-radius: 4px;
    min-width: 100%; 
    //min-height: 100%;
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
    max-height: 60px;
    max-width : 60px;
    vertical-align : middle;
    object-fit: cover;
`;

const SpaceDetail = ({ location }) => {

    // 컨텐츠 정보
    const [contentsInfo, setContentsInfo] = useState(null);

    //모바일에서 더보기 버튼 동작
    const [showMore, setShowMore] = useState(false);
    const [showMoreText, setShowMoreText] = useState('상세설명 펼치기')

    const dispatch = useDispatch();
    const history = useHistory();
    const wingRef = useRef(null);
    const refProduct = useRef(null);
    const refBottom = useRef(null);
    const refWing = useRef(null);
    const refBtnShowMore = useRef(null);

    const [fixWing, setFixWing] = useState(true);

    //공간찜 추가
    const [openModalLogin, setOpenModalLogin] = useState(false);
    const [isClipAdd, setIsClipAdd] = useState(false);
    const [isClipDel, setIsClipDel] = useState(false);
    const [fromLoginPU, setFromLoginPU] = useState(false);

    const scrollToBtn = (ref) => window.scrollTo(0, (ref.current.offsetTop - 400), { behaviour: 'smooth' });

    const [openModalCntOver, setOpenModalCntOver] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [msg, setMsg] = useState(null);
    const [kind, setKind] = useState(0);
    const [cartItem, setCartItem] = useState(null);
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalCnt, setTotalCnt] = useState(0);

    const { loading, stDetail, locinfo, stItemsDetail, clipSpaceIds, spaceClipResult, id, accessToken, cartProdList } = useSelector(
        ({ loadingReducer, stContentsReducer, userSpaceReducer, userReducer, userCartReducer }) => ({
            loading: loadingReducer['sp/ST_ITEM'],
            stDetail: stContentsReducer.stDetail,
            locinfo: stContentsReducer.locinfo,
            stItemsDetail: stContentsReducer.stItemsDetail,
            clipSpaceIds: userSpaceReducer.clipSpaceIds, // 공간찜 추가
            spaceClipResult: userSpaceReducer.spaceClipResult,
            id: userReducer.id,
            accessToken: userReducer.accessToken,
            cartProdList: userCartReducer.cartProdList,
        })
    );

    useEffect(() => {

        window.scrollTo(0, 0);
        setTimeout(() => {
            onLoadBox();
        }, 200);

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);

    }, []);

    useEffect(() => {

        window.scrollTo(0, 0);

    }, [location]);

    const onScroll = () => {

        if (refBottom.current) {
            if (window.scrollY < refBottom.current.offsetTop - 890) {
                setFixWing(true);
                if (refWing.current && refProduct.current) {
                    const product = refProduct.current;
                    const wing = refWing.current;
                    var offset = $(product).offset().left;
                    $(wing).css('left', offset + 856);

                }
            }
            else {
                setFixWing(false);
                if (refWing.current && refProduct.current) {
                    const wing = refWing.current;
                    $(wing).css('left', 856);

                }
            }
        }

    };

    useEffect(() => {
        if (refBottom.current) {
            if (window.scrollY < (refBottom.current.offsetTop)) {
                setFixWing(true);
                if (refWing.current && refProduct.current) {
                    const product = refProduct.current;
                    const wing = refWing.current;
                    var offset = $(product).offset().left;
                    $(wing).css('left', offset + 856);
                }
            }
            else {
                setFixWing(false);
                if (refWing.current && refProduct.current) {
                    const wing = refWing.current;
                    $(wing).css('left', 856);
                }
            }
        }

    }, [refWing.current, refProduct.current, refBottom.current]);

    //상품 찜 추가
    useEffect(() => {
        if (accessToken !== null) {
            onCloseModalLogin();
            dispatch(spaceAction(id));
        }
        else {
            dispatch(setClipSpaceIdAction(null));
        }

        return () => {
        };

    }, [accessToken]);

    useEffect(() => {

        if (isClipAdd) {
            if (clipSpaceIds === null || clipSpaceIds === undefined || (clipSpaceIds && clipSpaceIds.length < 1)) {
                let clipSum = [];
                clipSum.push(contentsInfo.st_id);
                dispatch(setClipSpaceIdAction(clipSum));
                setIsClipAdd(false);
            }
            else {
                let clipSum = [...new Set(clipSpaceIds.concat(contentsInfo.st_id))];
                dispatch(setClipSpaceIdAction(clipSum));
                setIsClipAdd(false);
            }
        }
        else if (isClipDel) {
            if (clipSpaceIds != null) {
                let clipSum = [...clipSpaceIds];
                remove(clipSum, (obj) => { return obj === contentsInfo.st_id })
                dispatch(setClipSpaceIdAction(clipSum));
                setIsClipDel(false);
            }
        }

    }, [spaceClipResult]);

    //로그인 팝업 뜨고 로그인 완료 후, 좋아요 리스트 요청(메인화면에서 요청) 후 처리.
    useEffect(() => {
        if (accessToken !== null && fromLoginPU === true) {

            //로그인 완료 후 이미 좋아요 포함되어 있는 경우 요청하지 않음.
            if (clipSpaceIds != null && clipSpaceIds.length > 0 && clipSpaceIds.includes(contentsInfo.st_id)) {

            }
            else {
                dispatch(setUserSpaceAddAction(id, contentsInfo.st_id));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
            setFromLoginPU(false);
        }

    }, [clipSpaceIds]);

    useEffect(() => {
        if (!refProduct.current) return;
        setShowMoreText(showMore ? '상세설명 접기' : '상세설명 펼치기');
        isMobileOnly && showMore ? refProduct.current.classList.remove('hidden-on-mobile') : refProduct.current.classList.add('hidden-on-mobile');
        if (isMobileOnly) {
            !!showMore ? refProduct.current.classList.remove('hidden-on-mobile') : refProduct.current.classList.add('hidden-on-mobile');
            if (!showMore) window.setTimeout(() => { scrollToBtn(refBtnShowMore) }, 500)
        }

    }, [showMore])

     // 모달 닫기
     const handleModalClose = () => {
        setOpenModal(false);
    }

    // 모달 첫번째 버튼 처리
    const handleModalBtn1Click = () => {
        if(kind === 0){
            return history.push("/mycart")
        }
        else if(kind === 1){
            const reqApplyItems = getApplyItems(true);

            var tmpList = [];
            let tmpItem = { 'brnd_id': reqApplyItems[0].brnd_id, 'list': reqApplyItems };
            tmpItem.price=0;

            tmpList.push(tmpItem);

            dispatch(setUserReqProdsListAction(tmpList));
            history.push('/requestform');
           /*  let totlaPrice = 0;
            let totalCnt = 0;
            //console.log("reqApplyItems = " + JSON.stringify(reqApplyItems));
            forEach(reqApplyItems, (curobj, index) => {
                //curobj.es_prdct_price = (curobj.es_opt_pirce * 1) * curobj.qty;
                totlaPrice += (curobj.es_opt_pirce * 1);
                totalCnt += (curobj.qty * 1);
            });

            setCartItem(reqApplyItems);

            setTotalPrice(totlaPrice);
            setTotalCnt(totalCnt);

            setKind(2);
            setOpenModal(true); */
        }
    }

    // 모달 두번째 버튼 처리
    const handleModalBtn2Click = () => {
        handleModalClose();
    }

    const onOpenModalLogin = () => {
        setOpenModalLogin(true);
    }

    // Modal 닫기
    const onCloseModalLogin = () => {
        setOpenModalLogin(false);
    }

    const onHandleLike = () => {
        //비로그인
        if (accessToken === null) {
            onOpenModalLogin();
            setFromLoginPU(true); //로그인 팝업 후, 종료시 다시 요청하기 위해서..
        }
        else {
            if (clipSpaceIds != null && clipSpaceIds.length > 0 && clipSpaceIds.includes(contentsInfo.st_id)) {
                dispatch(setUserSpaceDelAction(id, contentsInfo.st_id));
                setIsClipAdd(false);
                setIsClipDel(true);
            }
            else {
                dispatch(setUserSpaceAddAction(id, contentsInfo.st_id));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
        }

    }

    const getLikeBtnImg = () => {
        //비로그인
        if (accessToken === null) {
            return "/assets/images/icon/favorite-icon-gray.png"
        }
        else {
            if (clipSpaceIds != null && clipSpaceIds.length > 0 && clipSpaceIds.indexOf(contentsInfo.st_id) > -1) {
                return "/assets/images/icon/favorite-icon-active.png"
            }
            else {
                return "/assets/images/icon/favorite-icon-gray.png"
            }

        }
    }

    useEffect(() => {

        // 최초 실행시 처리
        dispatch(setCurMenuAction('st/detail'));
        dispatch(setHeaderTransferAction(false));

        // console.log("stItem : " + JSON.stringify(stDetail))

        // 조회 Query State가 없으면 404 Error
        if (location.search === null || location.search === undefined) {
            history.push("/notfound");
        } else {
            // console.log("location.search : " + location.search);
            if (location.search !== locinfo) {
                dispatch(reqStItemAction(location.search));
                dispatch(setStLocAction(location.search));
                let param = "?offset=0&limit=50";
                dispatch(reqStContentsDetailAction(param));
            } else if (stDetail !== null && stDetail !== undefined) {
                setContentsInfo(stDetail);
            }
        }

    }, [stDetail, stItemsDetail, location])

    // 매번 렌더링 될때마다 스크롤 위치를 정위치로 변경해 준다.
    //window.scrollTo(0, 0);
    // console.log("stItems : " + JSON.stringify(stItems))

    if (stItemsDetail !== null && stDetail !== null) {
        remove(stItemsDetail, (curitem) => {
            return curitem.st_id === stDetail.st_id;
        })
    }

    const setEsBoxPosition = (fixWing) => {
        let left = '916px';
        if (fixWing&&refWing.current && refProduct.current) {
            const product = refProduct.current;
            const wing = refWing.current;
            var offset = $(product).offset().left;
            $(wing).css('left', offset + 856);
            left = offset+856+'px';
        }

        let style = fixWing ? { position: 'fixed', left: left, bottom: 'auto', marginTop: '30px' } : { position: 'absolute', left: '856px', bottom: '100px', marginTop: '30px' }
        return isMobileOnly ? { marginTop: '30px' } : style;
    }

    const onClickShowMore = () => {
        setShowMore(!showMore);
    }

    const handlerClickSubmit = () => {

        const reqApplyItems = getApplyItems(false);

        let totlaPrice = 0;
        let totalCnt = 0;
        let soldOutCnt = 0;

        //console.log("reqApplyItems = " + JSON.stringify(reqApplyItems));

        forEach(reqApplyItems, (curobj, index) => {
            //curobj.es_prdct_price = (curobj.es_opt_pirce * 1) * curobj.qty;
            totlaPrice += (curobj.es_opt_pirce * 1);
            totalCnt += (curobj.qty * 1);
            if(curobj.sell_status !== '020102'){
                soldOutCnt++;
                //console.log("soldout1 = " + curobj.prdct_nm);
            }else{
                if(curobj.opt_id > 0 && curobj.opt_status !== 1){
                    soldOutCnt++;
                    //console.log("soldout2 = " + curobj.prdct_nm);
                }
            }

        });

        if(soldOutCnt > 0){
            setKind(1);
            setOpenModal(true);
        }
        else{
            var tmpList = [];
            let tmpItem = { 'brnd_id': reqApplyItems[0].brnd_id, 'list': reqApplyItems };
            tmpItem.price=0;

            tmpList.push(tmpItem);

            dispatch(setUserReqProdsListAction(tmpList));
            history.push('/requestform');

            /* setCartItem(reqApplyItems);

            setTotalPrice(totlaPrice);
            setTotalCnt(totalCnt);

            setKind(2);
            setOpenModal(true); */
        }

    }

    const getApplyItems = (sold_out) => {
        const reqApplyItems = contentsInfo.prods.reduce((resultObj, curobj, idx) => {
            let addItem = esApplyProdDao();
            addItem.prdct_id = curobj.prdct_id;
            addItem.prdct_nm = curobj.prdct_nm;
            addItem.opt_id = curobj.opt_id;
            addItem.opt_nm = curobj.opt_nm;
            //addItem.cate_name = prodinfo.cate2_name;
            addItem.prdct_price = curobj.prdct_price; // 판매가
            addItem.sale_price = curobj.sale_price;
            addItem.es_prdct_price = curobj.price; // 견적 요청 상품 금액 ( 옵션 금액 포함 )
            //addItem.es_opt_pirce = curobj.opt_price; // 옵션 금액
            // addItem.es_opt_pirce = curobj.price; // 옵션 금액
            addItem.es_opt_pirce = curobj.price/curobj.qty; // 옵션 금액 price 로 하면 qty>1 인 경우 버그발생 JP
            addItem.qty = curobj.qty;
            addItem.img = curobj.repr_img;
            addItem.brnd_id = contentsInfo.brand_id;
            addItem.brnd_nm = contentsInfo.brnd_han;
            addItem.brnd_logo_url = contentsInfo.brnd_logo_url;
            //[START] #2726 수정
            try {
                addItem.brnd_cd = contentsInfo.brndinfo[0].brnd_cd;
            }
            catch (e) {
                // Do nothing!
                console.log("brand_cd error");
            }
            //[END] #2726 수정

            addItem.sell_status = curobj.sell_status;
            addItem.opt_status = curobj.opt_status;

            //품절 상품 포함 여부
            if(sold_out === true){
                if(curobj.sell_status !== '020102'){
                    //soldOutCnt++;
                    //console.log("soldout1 = " + curobj.prdct_nm);
                }else if(curobj.opt_id > 0 && curobj.opt_status !== 1){
                        //soldOutCnt++;
                        //console.log("soldout2 = " + curobj.prdct_nm);
                }
                else{
                    resultObj.push(addItem);
                }

            }
            else{
                resultObj.push(addItem);
            }

            return resultObj;
        }, []);

        return reqApplyItems;
    }
    const onHandleCart = () => {

        // 기존에 브랜드 아이디가 없는 항목은 삭제
        remove(cartProdList, (curitem) => {
            return curitem.brnd_id === 0;
        })

        const reqApplyItems = getApplyItems(false);

        // [START] #2605 - 신규 추가 인데, 브랜드 갯수가 30개 이상이면 추가 안됨
        let brndCnt = 0;
        if (cartProdList !== undefined && cartProdList !== null) {
            forEach(cartProdList, (curItem) => {
                if (curItem.brnd_id !== undefined && curItem.brnd_id === contentsInfo.brand_id) {
                    brndCnt++;
                }
            })
        }
        // [END] #2605 - 신규 추가 인데, 브랜드 갯수가 30개 이상이면 추가 안됨

        if (brndCnt + reqApplyItems.length > CONSTANTS.MAX_PROD) {
            setOpenModalCntOver(true);
        } else {
            if (accessToken !== null) {

                reqApplyItems.map((curitem) => {

                    // 추가할 아이템이 이미 추가 되어 있는지 확인
                    let objIdx = findIndex(cartProdList, (obj) => {
                        return (obj.prdct_id === curitem.prdct_id && obj.opt_id === curitem.opt_id);
                    })

                    // console.log(objIdx + " : " + JSON.stringify(arrAddItems));
                    // 신규 추가 의 경우
                    if (objIdx === -1) {
                        if (curitem.brnd_id !== 0
                            && curitem.brnd_nm !== null
                            && curitem.brnd_nm.length > 0) {
                            cartProdList.push(curitem);
                        }

                    } else {
                        // 갯수 증가 시키고 전체 금액 계산
                        let qty = ++cartProdList[objIdx].qty;
                        let price = cartProdList[objIdx].es_opt_pirce;
                        cartProdList[objIdx].es_prdct_price = (price * qty);
                    }

                    return null;
                })

                dispatch(syncUserCartAction(cartProdList));
            } else {
                dispatch(setUserCartProdsAction(reqApplyItems));
            }
            // 모달 표시
            setKind(0);
            setCartName();
            setOpenModal(true);
        }

    }

    const getCartBtnImg = () => {
        return "/assets/images/icon/es_cart-icon.png"
    }

    const getCartBgColor = () => {

        return "#e0e0e0"
    }

    const setCartName = () => {
        //let count = contentsInfo.prods.length-1;
        //let name = "{" + contentsInfo.prods[0].prdct_nm + "}" + " 외 " + count + "개의 상품이 장바구니에 추가되었습니다.";
        let name = "장바구니에 추가 되었습니다."
        setMsg(name);
    }

    const getPopup = () => {
        if (kind === 0) {
            return (<NormalPopup
                text=""
                text2={msg} text3=""
                btn1="상품 보러가기"
                btn2="닫기"
                onClick1={handleModalBtn1Click}
                onClick2={handleModalBtn2Click} />);
        } else if (kind === 1) {
            let msg = "품절된 옵션이 있습니다.\n 제외 후 요청서 페이지로 이동합니다!";
            return (<NormalPopup
                text=""
                text2={msg} text3=""
                btn1="확인"
                btn2="취소"
                onClick1={handleModalBtn1Click}
                onClick2={handleModalBtn2Click} />);
        } else {
            return (<EsReqForStPopup
                totalPrice2={totalPrice}
                totalCnt2={totalCnt}
                cartItem2={cartItem}
                onCloseClick={handleModalClose} />);
        }

    }

    const getPopupStyle = () => {
        if (kind < 2) {
            return customModalStyles;
        } else {
            return EsReqForStPopupModalStyles;
        }
    }

    const getSubmitDisableStatus = () =>{
        if(contentsInfo === null){
            return false;
        }
        let soldOutCnt = 0;


        forEach(contentsInfo.prods, (curobj, index) => {
            if(curobj.sell_status !== '020102'){
                soldOutCnt++;
                //console.log("soldout1 = " + curobj.prdct_nm);
            }else{
                if(curobj.opt_id > 0 && curobj.opt_status !== 1){
                    soldOutCnt++;
                    //console.log("soldout2 = " + curobj.prdct_nm);
                }
            }
        });

        if(soldOutCnt === contentsInfo.prods.length){
            return true;
        }

        return false;
    }

    const onLoadBox = () => {
        if (refWing.current && refProduct.current) {
            
            if (refBottom.current&&window.scrollY < refBottom.current.offsetTop - 890) {
                setFixWing(true);
                $(wing).css('position', 'fixed');
                const product = refProduct.current;
                const wing = refWing.current;
                var offset = $(product).offset().left;
                $(wing).css('left', offset + 856);
            }
            else {
                setFixWing(false);
                if (refWing.current && refProduct.current) {
                    const wing = refWing.current;
                    $(wing).css('left', 856);
                }
            }
        }
    }

    if (contentsInfo === null) {
        return <SpaceDetailBlock />
    }

    return (

        <SpaceDetailBlock>
            <Header />
            <SpaceHeaderBlock>
                <div>
                    <div className='sz-wrap clearfix'>
                        <span className="sd-no font-mont">NO. <span>{contentsInfo.st_id}</span></span>
                        <div className="sd-title">
                            {/* <p className="sd-logo">
                                <img src={contentsInfo.brnd_logo_url} alt="" />
                            </p> */}
                            <span>{contentsInfo.brnd_han}&nbsp;<span style={{ fontWeight: '900' }}>&middot;</span>&nbsp;{contentsInfo.cntnts_nm}</span>
                        </div>
                        <div className="sd-fc">
                            <IconBtn width='26px' height='24px'
                                onClick={onHandleLike}
                                img={getLikeBtnImg()} />
                            {/* <button type="button" className="share-btn margin_l-20"></button> */}
                        </div>
                    </div>
                </div>
            </SpaceHeaderBlock>
            <SpaceDetailContainerBlock>
                <SpaceContentsBlock className="clearfix">
                    <div className="sd-product_info hidden-on-mobile" ref={refProduct} >
                        <div dangerouslySetInnerHTML={{ __html: contentsInfo.cntnts_detail }}
                        >
                        </div>
                        <div className="default-table" style={isMobileOnly ? {paddingBottom:'30px'} : {}}>
                            <table className="margin_b-30   ">
                                <colgroup>
                                    <col width="180px;" />
                                    <col width="652px;" />
                                </colgroup>

                                <tbody>
                                    <tr>
                                        <td className="gray">공간</td>
                                        <td>{contentsInfo.space_fltr_data}</td>
                                    </tr>
                                    <tr>
                                        <td className="gray border_bottom">가족형태</td>
                                        <td className="border_bottom">{contentsInfo.family_fltr_data}</td>
                                    </tr>
                                    <tr>
                                        <td className="gray border_bottom">스타일</td>
                                        <td className="border_bottom">{contentsInfo.style_fltr_data}</td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* <p className="ess_text">
                                ※ 특별 견적 금액에 배송비 금액이 포함되어있지 않습니다.
                                        <br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;배송비는 해당 브랜드의 배송 정책에 따릅니다.
                                    </p> */}
                        </div>
                        <BtnShowMoreBlock ref={refBtnShowMore} className="show-more" onClick={() => onClickShowMore()}>{showMoreText}</BtnShowMoreBlock>
                    </div>
                    {/*<div className="divider"/>*/}
                    <div className="sd-es_box" ref={refWing} style={setEsBoxPosition(fixWing)} /* onLoad={onLoadBox} */>

                        <div className="margin_b-30 text_center" >

                            {/* 특별 견적 기능 추가시 까지 비노출 처리  */}
                            <p className="sd-limit_date margin_b-10" style={{ display: 'none' }} >
                                유효기간 : <span className="font-mont">2020.02.20</span>
                            </p>

                            <div className="sd-pay" >
                                <p>총 상품 금액</p>
                                <p className="pay-detail">
                                    <span className="font-mont">
                                        {Number((contentsInfo.totalprice * 1).toFixed(1)).toLocaleString()}
                                    </span>원</p>
                            </div>
                        </div>
                        <div>
                            {/* 특별 견적 기능 추가시 까지 비노출 처리  */}
                            <div style={{ display: 'none' }}>
                                <p className="sd-all_pay">총 상품 금액<span className="f-right" >
                                    <span className="font-mont">
                                        {Number((contentsInfo.totalprice * 1).toFixed(1)).toLocaleString()}
                                    </span>원</span>
                                </p>
                            </div>


                            <div className="product-table default-table small_scroll" style={{ borderBottom: '1px solid #e7e7e7', borderTop: '2px solid #111' }}>
                                <table >
                                    <colgroup>
                                        <col width="60px;" />
                                        <col width="254px;" />
                                    </colgroup>

                                    <tbody>
                                        {
                                            contentsInfo.prods.map((curprod, index) => {
                                                return (
                                                    <tr key={index} className="sd_es-tr">
                                                        {(curprod.opt_id > 0 && curprod.opt_status < 1) || curprod.sell_status !== '020102'  ?
                                                            <td style={index===0 ? {borderTop:'none'} : {}}>
                                                                <SpaceProdItemPBlock className="product-thumbnail">
                                                                    {curprod.sell_status !== '020102' ?
                                                                    <div>
                                                                        <SpaceProdListItemImg src={curprod.repr_img} alt="" />
                                                                    </div>
                                                                    :
                                                                    <Link to={"/prod?prodid=" + curprod.prdct_id}>
                                                                        <SpaceProdListItemImg src={curprod.repr_img} alt="" />
                                                                    </Link>
                                                                    }

                                                                    <SpaceProdItemDimPBlock/>
                                                                </SpaceProdItemPBlock>
                                                            </td>
                                                        :
                                                            <td style={index===0 ? {borderTop:'none'} : {}}>
                                                                <SpaceProdItemPBlock className="product-thumbnail">
                                                                    <Link to={"/prod?prodid=" + curprod.prdct_id}>
                                                                        <SpaceProdListItemImg src={curprod.repr_img} alt="" />
                                                                    </Link>
                                                                </SpaceProdItemPBlock>
                                                            </td>
                                                        }
                                                        {(curprod.opt_id > 0&& curprod.opt_status < 1) || curprod.sell_status !== '020102' ?
                                                            <td className="pt_title-box" style={index===0 ? {borderTop:'none', color:'#bbbbbb'} : {color:'#bbbbbb'}}>
                                                                <p className="pt-title" style={{ fontSize: '13px', lineHeight: '18px' }}>
                                                                    {curprod.sell_status !== '020102' ?
                                                                    <div>
                                                                    <span className="font-mont">{"(품절) "}{curprod.prdct_nm}</span>
                                                                    </div>
                                                                    :
                                                                    <Link to={"/prod?prodid=" + curprod.prdct_id}>
                                                                    <span className="font-mont">{"(품절) "}{curprod.prdct_nm}</span>
                                                                    </Link>
                                                                    }

                                                                </p>
                                                                <div style={{ float: 'left', fontSize: '14px' }}>
                                                                    {curprod.qty} 개
                                                                </div>
                                                                {/* 갯수 , 옵션가 까지 포함된 금액 표시  */}
                                                                <div style={{ float: 'right', marginRight: '10px' }}>
                                                                    <SpanPrice value={(curprod.sale_price + curprod.opt_price) * curprod.qty} isSale={false} fontSize='16px' isDim={true} />
                                                                    {
                                                                        curprod.sale_price === curprod.prdct_price ? '' :
                                                                            <SpanPrice value={(curprod.prdct_price + curprod.opt_price) * curprod.qty} isSale={true} fontSize='14px' isDim={true} />
                                                                    }
                                                                </div>


                                                                {/*  #2510 적용 */}
                                                                <div style={{ display: 'none', color:'#bbbbbb' }}>
                                                                    <div className="pt-option" style={{ display: curprod.opt_nm !== null ? 'block' : 'none' }}>
                                                                        <p>옵션 : <span>{curprod.opt_nm}</span></p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        :
                                                            <td className="pt_title-box" style={index===0 ? {borderTop:'none'} : {}}>
                                                                <p className="pt-title" style={{ fontSize: '13px', lineHeight: '18px' }}>
                                                                    <Link to={"/prod?prodid=" + curprod.prdct_id}>
                                                                        <span className="font-mont">{curprod.prdct_nm}</span>
                                                                    </Link>
                                                                </p>
                                                                <div style={{ float: 'left', fontSize: '14px', color: '#999' }}>
                                                                    {curprod.qty} 개
                                                                </div>
                                                                {/* 갯수 , 옵션가 까지 포함된 금액 표시  */}
                                                                <div style={{ float: 'right', marginRight: '10px' }}>
                                                                    <SpanPrice value={(curprod.sale_price + curprod.opt_price) * curprod.qty} isSale={false} fontSize='16px' />
                                                                    {
                                                                        curprod.sale_price === curprod.prdct_price ? '' :
                                                                            <SpanPrice value={(curprod.prdct_price + curprod.opt_price) * curprod.qty} isSale={true} fontSize='14px' />
                                                                    }
                                                                </div>


                                                                {/*  #2510 적용 */}
                                                                <div style={{ display: 'none' }}>
                                                                    <div className="pt-option" style={{ display: curprod.opt_nm !== null ? 'block' : 'none' }}>
                                                                        <p>옵션 : <span>{curprod.opt_nm}</span></p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        }

                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>


                            {/* <button type="submit" className="es-submit gray-btn">같은 견적 요청하기 (오픈 예정)</button> */}
                        </div>


                        <div className="action-block margin_t-20">
                            <div style={{ float: "left", width: "60px" }}>
                                <NormalBtn
                                    width="100%" height="60px"
                                    marginTop="0px"
                                    bgColor={getCartBgColor()}
                                    img={getCartBtnImg()}
                                    onClick={() => onHandleCart()}
                                />
                            </div>
                            <div style={{ float: "right", width: (isMobileOnly ? '85vw' : '244px'), marginLeft: '10px' }}>
                                {getSubmitDisableStatus() === false ?
                                    <SubmitBtn text='같은 견적 요청하기'
                                    marginTop="0px"
                                    width="100%" height="60px"
                                    textColor="#fff" bgColor="#111"
                                    arrowColor="#fff"
                                    onClick={handlerClickSubmit} />
                                :
                                    <SubmitBtn text='품절'
                                    marginTop="0px"
                                    width="100%" height="60px"
                                    textColor="#bbbbbb" bgColor="#e0e0e0"
                                    arrowColor="#fff"
                                    />
                                }


                            </div>
                        </div>

                        {/* <p className="ess_text margin_t-20 gray text_center">※ 배송비는 해당 브랜드의 배송 정책을 따름</p> */}
                    </div>
                </SpaceContentsBlock>

                <div ref={refBottom}>
                    <div className="default-table margin_b-10 brand-container">
                        <h3 className="dt-title">브랜드 소개</h3>
                        <div className="brand-contents-box clearfix">
                            <div className="pd_brand-box f-left">
                                <div className="brand-box" style={{ paddingTop: '40px', height: '230px' }}>
                                    <p className="dt-logo" style={{ marginBottom: '30px' }}>
                                        <img src={contentsInfo.brnd_logo_url} alt="" />
                                        {/* <span>{contentsInfo.brnd_han}</span> */}
                                    </p>
                                    <p style={{ fontSize: '14px', lineHeight: '20px' }}>
                                        {contentsInfo.brnd_info_brief}
                                    </p>

                                    <Link to={"/brHome/" + contentsInfo.brand_id}>
                                        <div className="bs-info-btn">BRAND HOME</div>
                                    </Link>



                                </div>
                            </div>


                            <ul className="rb-list" style={{/*{width: '100%'}*/ }}>
                                {
                                    contentsInfo.brnd === null ? '' :
                                        contentsInfo.brnd.map((curprod, index) => {
                                            return (
                                                <li key={index} style={{ width: '182px' }}>
                                                    <Link to={"/prod?prodid=" + curprod.prdct_id} >
                                                        <ProdItemPBlock className="rb-list_img">
                                                            <ProdListItemImg src={curprod.repr_img} alt="" />
                                                        </ProdItemPBlock>
                                                        <span className="product_title">{curprod.prdct_nm}</span>
                                                        <span className="product_pay">{Number((curprod.sale_price * 1).toFixed(1)).toLocaleString()}</span>
                                                    </Link>
                                                </li>
                                            )
                                        })
                                }
                            </ul>

                        </div>
                    </div>

                    <div className="recco-slide default-table">
                        <div style={{ height: '38px' }}>
                            <h3 className="dt-title" style={{ float: 'left' }}>
                                다음 공간투어는 어디?
                        </h3>
                            <Link to="/st" style={{ textDecoration: 'underline', float: 'right' }}>전체보기</Link>
                        </div>
                        {
                            stItemsDetail === null || stItemsDetail === undefined ? '' :
                                <SpaceEsSlider items={stItemsDetail} count={stItemsDetail.length} location={location} />
                        }
                    </div>
                </div>

            </SpaceDetailContainerBlock>
            <div className="bottom-banner"><SrMyCartBanner /></div>
            <Footer />
            <Modal
                isOpen={openModalLogin}
                onRequestClose={onCloseModalLogin}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModalLogin}/>
            </Modal>
            <Modal
                isOpen={openModalCntOver}
                onRequestClose={() => { setOpenModalCntOver(false) }}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <NormalPopupOneBtn
                    text=""
                    text2={`견적 요청은 ${CONSTANTS.MAX_PROD}개 이하만 가능합니다!`}
                    text3="조금만 덜어주세요. :-)"
                    btn="닫기"
                    onClick={() => { setOpenModalCntOver(false) }} />
            </Modal>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}

            </Modal>


           {/*  <Modal isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <NormalPopup
                    text=""
                    text2={msg} text3=""
                    btn1="상품 보러가기"
                    btn2="닫기"
                    onClick1={handleModalBtn1Click}
                    onClick2={handleModalBtn2Click} />
            </Modal>
            <Modal
                isOpen={openModalEs}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <EsReqInfoPopup
                totalPrice={totalPrice}
                totalCnt={totalCnt}
                availCnt={availCnt}
                cartItem={cartItem}
                onCloseClick={handleModalBtn2Click}
                handlerChangeCnt={handlerChangeQty}
                handlerDelClick={handleDelClickFromReqPopup} />

            </Modal> */}
        </SpaceDetailBlock>

    );
};

export default SpaceDetail;
